import Vue from 'vue'
import moment from 'moment-timezone'

Vue.filter('formatDate', function(value, {
    originalFormat ='',
    format    = 'MM/DD/YYYY',
    timeZone  = "America/Denver",
    localTime = false
}) {

    // console.log(moment(value).format(format), moment(value).tz(timeZone).format(format))
     console.log('format date', value)

     const isValidDate = moment(value).isValid()
     if(!isValidDate) return value

    if(localTime) {
        if(originalFormat) return value ? moment(value, originalFormat).format(format) : ''
        return value ? moment(value).format(format) : ''
    } 

    if(originalFormat) return value ? moment(value, originalFormat).tz(timeZone).format(format) : ''
    return value ? moment(value).tz(timeZone).format(format) : ''
})